import $ from 'jquery';
import Toggler from '../utils/toggler';

export default function headerSection() {
	const $html = $('html');
	const $header = $('#header');

	(function initSearch() {
		const $search = $header.find('.header_search');
		const $searchWrapper = $search.find('.header_search_wrapper');
		const $searchField = $search.find('.header_search_field');
		const $searchButton = $search.find('.header_search_button');

		const open = false;
		const transition = parseFloat($searchWrapper.css('transition-duration')) ? 'css' : false;
		const toggler = new Toggler($searchWrapper, { open, transition });

		toggler.on('open', () => $searchField.trigger('focus'));
		toggler.on('toggle', () => $header.toggleClass('is-search-open', toggler.isOpen));

		$searchButton.on('click', function(e) {
			if (!toggler.isOpen) {
				e.preventDefault();
				toggler.open();
			}
		});

		$search.on('click', (e) => e.stopPropagation());
		$html.on('click', () => toggler.close());

	}());
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js